import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollTracker from './components/ScrollTracker';
import ScrollProgress from './components/ScrollProgress';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import LoginPortal from './pages/portal/LoginPortal';
import PortalDashboard from './pages/portal/PortalDashboard';
import AdminPanel from './pages/admin/AdminPanel';
import { PortalProvider } from './context/PortalContext';

// Componente interno para controlar Navbar/Footer nas rotas do portal
const AppLayout = () => {
  const location = useLocation();
  const isPortal = location.pathname.startsWith('/portal') || location.pathname.startsWith('/admin');

  return (
    <div className="App min-h-screen bg-gray-50">
      {!isPortal && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceSlug" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* Portal de Assinantes */}
          <Route path="/portal" element={<LoginPortal />} />
          <Route path="/portal/dashboard" element={<PortalDashboard />} />
          {/* Admin */}
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </main>
      {!isPortal && <Footer />}
    </div>
  );
};

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  return (
    <PortalProvider>
      <Router>
        <ScrollToTop />
        <ScrollTracker />
        <ScrollProgress />
        <ErrorBoundary>
          <AppLayout />
        </ErrorBoundary>
      </Router>
    </PortalProvider>
  );
}

export default App;